import React from "react";
import {
  Row,
  Col,
  Space,
  message,
  Button,
  Modal,
  Image,
  Drawer,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import { CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import AudioMeassage from "../store/AudiomessageStore";
import AudioMeassageAdd from "./AudioMeassageAdd";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { a } from "react-spring";
class Audiomessage extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.audiomessageStore = new AudioMeassage(this);
    this.companyStore = new CompanyStore(this);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      openAudioMsgForm: false,
      listDataUpdate: false,
      comp_value: "",

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        title: context.translate("_NAME_"),
        dataIndex: "name",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("audiomessage") && this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },

      {
        title: context.translate("_DESCRIPTION_"),
        dataIndex: "description",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_AUDIO_VIEW_"),
        dataIndex: "path",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          const audioSrc = `${config.fleetURL + "/" + record.path}`;

          return (
            <audio controls key={audioSrc}>
              <source src={audioSrc} type="audio/mpeg" />
            </audio>
          );
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("audiomessage") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("audiomessage") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      let setAudioData = this.context.viewStateStore.audioMsgObject;
      setAudioData =
        typeof setAudioData === "number"
          ? setAudioData
          : setAudioData.companyId;
      if (setAudioData !== "") {
        await this.audiomessageStore.loadData({
          companyId: setAudioData,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setAudioData
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          companyId: setAudioData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setAudioMsgStates({
      companyId: record.companyId,
    });
    await this.setState({ id: record.id });
    await this.setState({ openAudioMsgForm: true });
  };

  async onDelete(record) {
    console.log(record);
    const response = await this.audiomessageStore.deleteRecord({
      id: record.id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    if (this.state.companyId > 0) {
      await this.audiomessageStore.loadData({
        companyId: this.state.companyId,
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
      });
      await this.setState({ loadData: 1, loading: false });
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    console.log(comp.value);

    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });

    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  closeModal = () => {
    this.setState({ openAudioMsgForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openAudioMsgForm: false });
      await this.handleSearch();
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.audiomessageStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  style={{ width: 200 }}
                  value={this.state.comp_value ? this.state.comp_value : null}
                />
              </Space>
            </Col>

            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              {this.props.canCreate("audiomessage") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openAudioMsgForm: true, id: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.audiomessageStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.audiomessageStore?.audiomessageList}
            loading={this.audiomessageStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openAudioMsgForm && (
          <Drawer
            className="uploadExcelDrawer"
            // title="Driver Details"
            width={716}
            closeIcon={false}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_FILE_UPLOAD_")}
                <p className="formDescription">
                  {this.context.translate("_AUDIO_ADD_FORM_DESC_")}
                </p>
              </div>
            }
            open={this.state.openAudioMsgForm}
            onCancel={() => {
              this.setState({ openAudioMsgForm: false, discountId: "" });
            }}
          >
            <div style={{ height: "100%" }}>
              <AudioMeassageAdd
                id={this.state.id}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
Audiomessage.contextType = StoreContext;
export default observer(withRouter(Audiomessage));
